import { createVar, style, styleVariants } from '@vanilla-extract/css';
import {
  componentSpecificTokenVars,
  semanticTokenVars,
} from '@tundr/ds-tokens';
import {
  borderWidthVars,
  fontWeightVars,
  radiusVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { BASE_TRANSITION as TRANSITION_DURATION } from '../_shared/styles/motion';
import { LinkVariant } from './Link.types';

const linkTokens = componentSpecificTokenVars.link;
const ICON_SIZE = '1.2em';
const hoverEnabledSelector = '&:hover:not([aria-disabled="true"])';
const activeEnabledSelector = '&:active:not([aria-disabled="true"])';

const idleColor = createVar();
const hoverColor = createVar();
const pressedColor = createVar();
const disabledColor = createVar();

export const variantClasses = styleVariants({
  [LinkVariant.Primary]: {
    vars: {
      [idleColor]: linkTokens.default.default,
      [hoverColor]: linkTokens.default.hover,
      [pressedColor]: linkTokens.default.pressed,
      [disabledColor]: linkTokens.default.disabled,
    },
  },
  [LinkVariant.Secondary]: {
    vars: {
      [idleColor]: linkTokens.secondary.default,
      [hoverColor]: linkTokens.secondary.hover,
      [pressedColor]: linkTokens.secondary.pressed,
      [disabledColor]: linkTokens.secondary.disabled,
    },
  },
});

export const baseClass = style({
  display: 'inline',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  fontWeight: fontWeightVars.regular,
  color: idleColor,
  textDecoration: 'none',
  borderRadius: radiusVars.md,
  cursor: 'pointer',
  transition: `color ${TRANSITION_DURATION}`,
  selectors: {
    [hoverEnabledSelector]: {
      color: hoverColor,
    },
    [activeEnabledSelector]: {
      color: pressedColor,
    },
    '&:focus-visible': {
      outline: `${borderWidthVars.xs} solid ${semanticTokenVars.border.brand.base}`,
      outlineOffset: '2px',
    },
    '&[aria-disabled="true"]': {
      color: disabledColor,
      cursor: 'not-allowed',
    },
  },
});

export const labelClass = style({
  textDecoration: 'underline',
});

export const iconLeftClass = style({
  fontSize: ICON_SIZE,
  marginRight: spacingVars.xs,
});

export const iconRightClass = style({
  fontSize: ICON_SIZE,
  marginLeft: spacingVars.xs,
});
